import { useEffect } from 'preact/hooks';

interface UsePlacemarkersProps {
  bookId: string;
  chapterId: number;
  position?: number;
}

export const usePlacemarkers = ({
  bookId,
  chapterId,
  position = 0,
}: UsePlacemarkersProps) => {
  useEffect(() => {
    const updatePlacemarker = async () => {
      try {
        await fetch('/api/v0/placemarkers', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            bookId,
            chapterId,
            position,
          }),
          credentials: 'include',
        });
      } catch (error) {
        console.error('Failed to update placemarker:', error);
      }
    };

    if (bookId && chapterId) {
      updatePlacemarker();
    }
  }, [, bookId, chapterId, position]);
};
